import Footer from "../../components/footer/footer"
import Header from "../../components/header/header"
import ContactSection from "../../components/contact/contact";
import { customScript } from "../../common/customscript";
import { useEffect } from "react";
import SearchModel from "../../components/search_model/search";

const Contact = () => {
    useEffect(() => {
        customScript()
    }, [])

    return (
        <>
            <Header />
            <ContactSection />
            <Footer />
            <SearchModel/>
        </>
    )
}

export default Contact